import { NgModule } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {NewsPageComponent} from './pages/news-page/news-page.component';
import {NewsPageWrapperComponent} from './pages/news-page-wrapper/news-page-wrapper.component';
import {NewsPageMyNewsComponent} from './pages/news-page-my-news/news-page-my-news.component';
import {NewsDetailComponent} from '@shared/modules/shared-news-detail/components/news-detail/news-detail.component';
import {NewsResolver} from './resolvers/news-resolver.service';
import {HomeRoutes} from '@app/routes/home.routes';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: NewsPageWrapperComponent,
        children: [
          { path: '', component: NewsPageComponent, data: { key: 'allNews'}},
          { path: HomeRoutes.news.personal, component: NewsPageMyNewsComponent, data: { key: 'myNews'}},
        ],
      },
      { path: ':id', component: NewsDetailComponent, resolve: {newsEntry: NewsResolver} },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewsRouting { }
